import { InputAdornment, TextField } from '@mui/material';
import React, {
  ChangeEvent, useEffect, useState,
} from 'react';
import { Search } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import {
  ArrowUpDownIcon, ShuffleIcon,
} from '../../../../assets/TableIcons';
import { UnitData, UpdateExcelPayloadAction } from '../../utils/types';
import { RootState } from '../../../../redux/rootState';
import { getAllComponentSerialNumbersStart, setCompData, updateExcelDataComp } from '../../redux/oilReportSlice';
import NoData from '../../../../assets/NoData.svg';
import { GetListingPayload } from '../../../../utils/type';
import { ModalPaginationWithoutPageSize } from '../pagination/paginationWithoutPageSize';

export function ReplaceCompartment() {
  const {
    selectedCompartment, allComponentSerialNumbers,
    excelData, totalComponentSerialNumbers, serialNumber, unitData,
  } = useSelector((state:RootState) => state.oilReportReducer);
  const dispatch = useDispatch();
  // eslint-disable-next-line max-len
  // const selectedComp:string = useMemo(() => excelData.find((data) => data.ReportId === selectedCompartment)?.CompartmentSerialNumber || '', [selectedCompartment]);
  // const [prevComp, setPrevComp] = useState<string>(selectedComp);
  // eslint-disable-next-line max-len
  // const selectedUnit:string = useMemo(() => excelData.find((data) => data.ReportId === selectedCompartment)?.UnitSerialNumber || '', [selectedCompartment]);

  const [compPage, setCompUnitPage] = useState(1);
  const [compRowsPerPage, setCompUnitRowsPerPage] = useState(10);
  const [compSearchQuery, setCompUnitSearchQuery] = useState('');

  // useEffect(() => {
  //   if (compData?.length > 0) {
  //     setPrevComp(compData?.[0]?.ReplacedValue);
  //   }
  // }, [compData]);

  const handleCompData = () => {
    const payload:GetListingPayload = {
      page: compPage,
      rowsPerPage: compRowsPerPage,
      searchQuery: compSearchQuery,
      UnitSerialNumber: unitData?.length > 0 ? unitData?.[0]?.Value : serialNumber,
    };
    dispatch(getAllComponentSerialNumbersStart(payload));
  };

  useEffect(() => {
    handleCompData();
  }, [serialNumber]);

  const handleReplaceComp = (value: string) => {
    const ReplacedValue = excelData.find((data) => data.ReportId === selectedCompartment)?.CompartmentSerialNumber || '';
    const obj:UnitData = {
      ReportId: selectedCompartment,
      Value: value,
      ReplacedValue,
    };

    const updateExcelPayload:UpdateExcelPayloadAction = {
      unitSerialNumber: value,
      isReplaced: true,
    };

    dispatch(setCompData(obj));
    dispatch(updateExcelDataComp(updateExcelPayload));
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCompUnitSearchQuery(event.target.value);
    const payload:GetListingPayload = {
      page: compPage,
      rowsPerPage: compRowsPerPage,
      searchQuery: event.target.value,
    };
    dispatch(getAllComponentSerialNumbersStart(payload));
  };

  return (
    <div className="CustomTableContainer CustomTableBorderedContainer">
      <div className="CustomSearchTable">
        <TextField
          className="subHeaderTextfield"
          size="small"
          placeholder="Search..."
          value={compSearchQuery}
          onChange={handleChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
      </div>
      <div className="oilReportTableContainer">
        <div className="oilReportTableHead">
          <div className="headerTableCell wd-25">
            SN
            {' '}
            <ArrowUpDownIcon />
          </div>
          {/* <div className="headerTableCell wd-45">
            Selected Unit & Comp
            {' '}
            <ArrowUpDownIcon />
          </div> */}
          <div className="headerTableCell wd-75">
            Compartments
            {' '}
            <ArrowUpDownIcon />
          </div>
        </div>
        {totalComponentSerialNumbers > 0
          ? (
            <div className="oilReportTableBody">
              <div className="oilReportTableList">
                <div className="oilReportTableCell wd-25">1</div>
                {/* <div className="oilReportTableCell wd-45">{`${selectedUnit} & ${compData?.length > 0 ? selectedComp : prevComp}`}</div> */}
                <div className="oilReportTableCell wd-75">
                  {/* <div>{allComponentSerialNumbers?.[0]?.CompartmentSerialNumber}</div> */}
                  <div>
                    {(allComponentSerialNumbers?.[0]?.CompartmentSerialNumber
                        && allComponentSerialNumbers?.[0]?.CompartmentSerialNumber?.trim()?.length > 0
                        && ((allComponentSerialNumbers?.[0]?.CompartmentSerialNumber)?.match(/^ */)?.[0]?.length || 0) > 0)
                      ? (
                        <>
                          {allComponentSerialNumbers?.[0]?.CompartmentSerialNumber}
                          {(allComponentSerialNumbers?.[0]?.CompartmentSerialNumber?.match(/^ */)?.[0]?.length || 0) > 0 && (
                          <span style={{ color: 'red', marginLeft: '4px' }}>
                            (C
                            {(allComponentSerialNumbers?.[0]?.CompartmentSerialNumber?.match(/^ */)?.[0].length || 0) + 1}
                            )
                          </span>
                          )}
                        </>
                      )
                      : allComponentSerialNumbers?.[0]?.CompartmentSerialNumber}
                  </div>
                  <div
                    className="actionBtn"
                    title="Replace with this Compartment"
                    onClick={() => handleReplaceComp(allComponentSerialNumbers?.[0]?.CompartmentSerialNumber)}
                  >
                    <ShuffleIcon />
                  </div>
                </div>
              </div>
              {allComponentSerialNumbers?.slice(1)?.map((entry, index) => (
                <div className="oilReportTableList" key={entry.ReportId}>
                  <div className="oilReportTableCell wd-25">{index + 2}</div>
                  {/* <div className="oilReportTableCell noBorder wd-45">&nbsp;</div> */}
                  <div className="oilReportTableCell wd-75">
                    <div>
                      {(entry?.CompartmentSerialNumber
                        && entry?.CompartmentSerialNumber?.trim()?.length > 0
                        && ((entry?.CompartmentSerialNumber)?.match(/^ */)?.[0]?.length || 0) > 0)
                        ? (
                          <>
                            {entry?.CompartmentSerialNumber}
                            {(entry?.CompartmentSerialNumber?.match(/^ */)?.[0]?.length || 0) > 0 && (
                            <span style={{ color: 'red', marginLeft: '4px' }}>
                              (C
                              {(entry?.CompartmentSerialNumber?.match(/^ */)?.[0].length || 0) + 1}
                              )
                            </span>
                            )}
                          </>
                        )
                        : entry?.CompartmentSerialNumber}
                    </div>
                    <div
                      className="actionBtn"
                      title="Replace with this Compartment"
                      onClick={() => handleReplaceComp(entry.CompartmentSerialNumber)}
                    >
                      <ShuffleIcon />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )
          : (
            <div className="CustomTableContainer CustomTableBorderedContainer allCentered">
              <div className=""><img src={NoData} alt="No data found" /></div>
            </div>
          )}
      </div>
      <ModalPaginationWithoutPageSize
        rowsPerPage={compRowsPerPage}
        page={compPage}
        setRowsPerPage={setCompUnitRowsPerPage}
        setPage={setCompUnitPage}
        totalEntries={totalComponentSerialNumbers}
        handleData={handleCompData}
      />
    </div>
  );
}
